var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tab-wrapper" },
    [
      _vm.$mq === "mobile"
        ? _c(
            "button",
            {
              staticClass: "tab--accordion__header",
              class: _vm.headerClass,
              on: { click: _vm.activate },
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.heading))]),
              _c("icon", {
                staticClass: "tab--accordion__header__icon",
                attrs: { name: _vm.icon, width: "13px", height: "13px" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.$mq === "mobile"
        ? _c(
            "transition",
            {
              attrs: { name: "slide-vertical" },
              on: { "after-enter": _vm.setContentHeight },
            },
            [
              _vm.active
                ? _c(
                    "div",
                    {
                      ref: "content",
                      staticClass: "tab tab--accordion",
                      style: _vm.contentStyle,
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "tab__content" },
                        [_vm._t("default")],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm.active
        ? _c(
            "div",
            { ref: "content", staticClass: "tab", style: _vm.contentStyle },
            [_c("div", { staticClass: "tab__content" }, [_vm._t("default")], 2)]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }